/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
/* eslint-disable no-unused-vars*/
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useSubheader } from "../../../../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from "../../../../../../../_metronic/_partials/controls";
import Modal from "react-bootstrap/Modal";

import { ToastContainer, toast } from "react-toastify";
import { toastOption } from "../../../../../../../_metronic/_helpers";
import * as actions from "../../../../_redux/reconcile/reconcileAction";
import { ReconcileUIProvider } from "../../ReconcileUIContext";
import { useReconcileEditUIContext } from "../ReconcileEditUIContext";
import { getDonationReference } from "../../../../_redux/reconcile/reconcileCrud";
import * as Yup from "yup";
import { useDonationDetailUIContext } from "./ReconcileDetailUIContext";
// import { ReconcileDonationCard } from './reconcile-donation-list/ReconcileDonationCard'
// import { DonationCard } from './donation-list/DonationCard'
import { DonationList } from "./donation-payment-list/DonationPaymentList";
import { ReconcileList } from "./reconcile-list/ReconcileList";
import { ReconcileEditForm } from "./ReconcileEditForm";
import moment from "moment";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { DonationURL } from "../../../../../../config/UrlEndPoint";
import { Backdrop, makeStyles } from "@material-ui/core";
import { ProgressBar } from "react-bootstrap";
import MutationBank from "./MutationBank";
import SelectBankStatementModal from "./SelectBankStatementModal";
import SummaryTable from "./SummaryTable";
import Moment from "react-moment";
import { BlockOrg } from "../../../../../../RoleChecker";

export const ReconcileEdit = ({ history, id }) => {
  const dispatch = useDispatch();
  const { currentState } = useSelector(
    (state) => ({ currentState: state.reconcile }),
    shallowEqual
  );
  const { reconcileData, error, loadingProgress } = currentState;

  const [title, setTitle] = useState("");
  const [reconcileList, setReconcileList] = useState([]);
  const [addedReconcile, setAddedReconcile] = useState([]);
  const [removedReconcile, setRemovedReconcile] = useState([]);
  const [show, setShow] = useState(false);
  const [modalDisplay, setModalDisplay] = useState("");
  const [submitValue, setSubmitValue] = useState({});
  const [buttonType, setButtonType] = useState("");
  const [bankAccount, setBankAccount] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [bankStatementModal, setBankStatementModal] = useState(false);
  const [mutationBankData, setMutationBankData] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [deletedBankStatement, setDeletedBankStatement] = useState("");

  const selectedBankMutation = (values) => {
    if (id) {
      setMutationBankData(values);
      setDeletedBankStatement(reconcileData.bank_statement.uuid);
      setBankStatementModal(false);
    } else {
      setMutationBankData(values);
      setBankStatementModal(false);
    }
  };

  const donationDetailUIContext = useDonationDetailUIContext();
  const donationDetailUIProps = useMemo(() => {
    return {
      donationItem: donationDetailUIContext.donationItem, // Data Donasi nya
      setDonationItem: donationDetailUIContext.setDonationItem, // Data Donasi nya
    };
  }, [donationDetailUIContext]);
  const reconcileEditUIContext = useReconcileEditUIContext();
  const reconcileEditUIProps = useMemo(() => {
    return {
      donatur: reconcileEditUIContext.donatur, // Data Donatur
      trxDate: reconcileEditUIContext.trxDate,
      openNewDonatur: reconcileEditUIContext.openNewDonatur,
    };
  }, [reconcileEditUIContext]);

  const [triggerFetch, setTriggerFetch] = useState(false);
  const [amount, setAmount] = useState(0);

  if (error) {
    toast.error(error, toastOption);
  }
  // amount donasi
  let amountNonState = 0;

  reconcileList.forEach((donation) => {
    // console.log(amountNonState);
    return (amountNonState += parseInt(donation.amount));
  });

  // setAmount(amountNonState)
  const createSettleReconcile = (value) => {
    const formData = new FormData();
    // formData.append('donation_payments_add', donation_payments_add)
    // formData.append('donation_payments_remove', donation_payments_remove)
    if (reconcileList.length > 0) {
      for (const index in reconcileList) {
        let item = reconcileList[index];
        formData.append(`donation_payments[${index}][uuid]`, item.uuid);
        formData.append(`donation_payments[${index}][donation_uuid]`, item.donation_uuid);
      }
    }
    formData.append("uuid", id);
    formData.append("bank_account_uuid", value.bank_account_uuid);
    formData.append("diff_description", value.diff_description);
    formData.append("diff_amount", summaryData.diff);
    formData.append("bank_statement_amount", mutationBankData.amount);
    formData.append("bank_statement", mutationBankData.uuid);
    formData.append("amount", value.amount);
    formData.append("trx_date", value.trx_date);
    formData.append("file", value.file);

    dispatch(actions.createReconcile(formData)).then((response) => {
      handleCloseDialogSettle();
      dispatch(actions.fetchReconcile());
      // dispatch(actions.fetchReconcile())
      setTriggerFetch(true);
      backToList();
      toast.success(response, toastOption);
    });
    // console.log(donationDetailUIProps.donationItem);
    // console.log(formData);
  };

  const createDraftReconcile = (value) => {
    const formData = new FormData();
    // formData.append('donation_payments_add', donation_payments_add)
    // formData.append('donation_payments_remove', donation_payments_remove)
    if (reconcileList.length > 0) {
      for (const index in reconcileList) {
        let item = reconcileList[index];
        formData.append(`donation_payments[${index}][uuid]`, item.uuid);
        formData.append(`donation_payments[${index}][donation_uuid]`, item.donation_uuid);
      }
    }
    formData.append("uuid", id);
    formData.append("bank_account_uuid", value.bank_account_uuid);
    formData.append("diff_description", value.diff_description);
    formData.append("bank_statement_amount", mutationBankData.amount);
    formData.append("bank_statement", mutationBankData.uuid);
    formData.append("diff_amount", summaryData.diff);
    formData.append("amount", value.amount);
    formData.append("trx_date", value.trx_date);
    formData.append("file", value.file);
    dispatch(actions.createReconcileDraft(formData)).then((response) => {
      dispatch(actions.fetchReconcile());
      // dispatch(actions.fetchReconcile())
      setTriggerFetch(true);
      backToList();
      toast.success(response, toastOption);
    });
    // console.log(donationDetailUIProps.donationItem);
    // console.log(formData);
  };

  const editDraftReconcile = (value) => {
    const donation_payments_add = addedReconcile.filter(
      ({ uuid: id1 }) =>
        !reconcileData.donation_payment.some(({ uuid: id2 }) => id2 === id1)
    );
    const donation_payments_remove = removedReconcile.filter(({ uuid: id1 }) =>
      reconcileData.donation_payment.some(({ uuid: id2 }) => id2 === id1)
    );

    const formData = new FormData();
    // formData.append('donation_payments_add', donation_payments_add)
    // formData.append('donation_payments_remove', donation_payments_remove)
    if (donation_payments_add.length > 0) {
      for (const index in donation_payments_add) {
        let item = donation_payments_add[index];
        formData.append(`donation_payments_add[${index}][uuid]`, item.uuid);
        formData.append(`donation_payments_add[${index}][donation_uuid]`, item.donation_uuid);
      }
    }
    if (donation_payments_remove.length > 0) {
      for (const index in donation_payments_remove) {
        let item = donation_payments_remove[index];
        formData.append(`donation_payments_remove[${index}][uuid]`, item.uuid);
      }
    }
    formData.append("uuid", id);
    formData.append("bank_pooling_uuid", value.bank_pooling_uuid);
    formData.append("diff_description", value.diff_description);
    formData.append("bank_statement_amount", mutationBankData.amount);
    formData.append("bank_statement", mutationBankData.uuid);
    formData.append("bank_statement_add", mutationBankData.uuid);
    formData.append("bank_statement_remove", deletedBankStatement);
    formData.append("diff_amount", summaryData.diff);
    formData.append("amount", value.amount);
    formData.append("trx_date", value.trx_date);
    formData.append("file", value.file);

    dispatch(actions.editDraftReconcile(formData)).then((response) => {
      // donationDetailUIProps.setDonationItem([])
      dispatch(actions.fetchReconcile(id));
      // dispatch(actions.fetchReconcile())
      setTriggerFetch(true);
      backToList();
      toast.success(response, toastOption);
    });
  };

  const editSettleReconcile = (value) => {
    const donation_payments_add = addedReconcile.filter(
      ({ uuid: id1 }) =>
        !reconcileData.donation_payment.some(({ uuid: id2 }) => id2 === id1)
    );
    const donation_payments_remove = removedReconcile.filter(({ uuid: id1 }) =>
      reconcileData.donation_payment.some(({ uuid: id2 }) => id2 === id1)
    );

    const formData = new FormData();
    // formData.append('donation_payments_add', donation_payments_add)
    // formData.append('donation_payments_remove', donation_payments_remove)
    if (donation_payments_add.length > 0) {
      for (const index in donation_payments_add) {
        let item = donation_payments_add[index];
        formData.append(`donation_payments_add[${index}][uuid]`, item.uuid);
      }
    }
    if (donation_payments_remove.length > 0) {
      for (const index in donation_payments_remove) {
        let item = donation_payments_remove[index];
        formData.append(`donation_payments_remove[${index}][uuid]`, item.uuid);
      }
    }
    for (const index in reconcileList) {
      let item = reconcileList[index];
      formData.append(`donations[${index}][donation_uuid]`,item.donation_uuid);
    }
    formData.append("uuid", id);
    formData.append("bank_pooling_uuid", value.bank_pooling_uuid);
    formData.append("diff_description", value.diff_description);
    formData.append("bank_statement_amount", mutationBankData.amount);
    formData.append("bank_statement", mutationBankData.uuid);
    formData.append("bank_statement_add", mutationBankData.uuid);
    formData.append("bank_statement_remove", deletedBankStatement);
    formData.append("diff_amount", summaryData.diff);
    formData.append("amount", value.amount);
    formData.append("trx_date", value.trx_date);
    formData.append("file", value.file);

    dispatch(actions.editReconcile(formData)).then((response) => {
      handleCloseDialogSettle();
      // donationDetailUIProps.setDonationItem([])
      // dispatch(actions.fetchReconcile(id));
      // dispatch(actions.fetchReconcile())
      setTriggerFetch(true);
      // backToList();
      toast.success(response, toastOption);
    });
  };

  // set state untuk modal
  const [openDialogSettle, setOpenDialogSettle] = React.useState(false);

  const handleClickOpenDialogSettle = () => {
    setOpenDialogSettle(true);
  };

  const handleCloseDialogSettle = () => {
    setOpenDialogSettle(false);
  };

  const btnCreateSettleRef = useRef();
  const createSettleReconcileClick = () => {
    if (btnCreateSettleRef && btnCreateSettleRef.current) {
      btnCreateSettleRef.current.click();
    }
  };
  const btnEditSettleRef = useRef();
  const editSettleReconcileClick = () => {
    if (btnEditSettleRef && btnEditSettleRef.current) {
      btnEditSettleRef.current.click();
    }
  };

  const btnEditDraftRef = useRef();
  const editDraftReconcileClick = () => {
    if (btnEditDraftRef && btnEditDraftRef.current) {
      btnEditDraftRef.current.click();
    }
  };
  const btnCreateDraftRef = useRef();
  const createDraftReconcileClick = () => {
    if (btnCreateDraftRef && btnCreateDraftRef.current) {
      btnCreateDraftRef.current.click();
    }
  };

  const backToList = () => {
    history.push(`/donasi/settlement`);
  };

  useEffect(() => {
    let _title = id ? "Settlement" : "Tambah Settlement";
    dispatch(actions.fetchReconcile(id));

    setTitle(_title);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch, triggerFetch]);

  useEffect(() => {
    setAmount(0);
    // id && reconcileData && setReconcileList(reconcileData.donation_payment)
    id && reconcileData && setReconcileList(reconcileData.donation_payment);
    reconcileList.forEach((donation) => {
      // console.log(amountNonState);
      return setAmount((prevState) => {
        return (prevState += donation.total_amount);
      });
    });
    id && reconcileData && setBankAccount(reconcileData.bank_account_uuid);

    id && reconcileData && setMutationBankData(reconcileData.bank_statement);
  }, [reconcileData]);

  const addDonationToReconcile = (data) => {
    const oldList = [...reconcileList];
    const newList = [data].concat(oldList);
    const filteredList = newList.filter(
      (v, i, a) => a.findIndex((t) => t.uuid === v.uuid) === i
    );
    setReconcileList(filteredList);
    const newAddedList = [...addedReconcile];
    newAddedList.push(data);
    setAddedReconcile(newAddedList);
  };
  const addDonationToReconcileAll = (data) => {
    const oldList = [...reconcileList, ...data];
    const filteredList = oldList.filter(
      (v, i, a) => a.findIndex((t) => t.uuid === v.uuid) === i
    );
    setReconcileList(filteredList);
    const newAddedList = [...addedReconcile];
    for (const item of data) {
      newAddedList.push(item);
    }
    setAddedReconcile(newAddedList);
  };

  const removeDonationFromReconcile = (data) => {
    setReconcileList((prevState) => {
      const oldList = [...prevState];
      const newList = oldList.filter((item) => item.uuid != data);
      const oldAddedReconcileList = [...addedReconcile];
      const newAddedReconcileList = oldAddedReconcileList.filter(
        (item) => item.uuid != data
      );
      setAddedReconcile(newAddedReconcileList);
      const newRemovedList = [...removedReconcile];
      newRemovedList.push({ uuid: data });
      setRemovedReconcile(newRemovedList);
      return newList;
    });
  };

  const removeDonationFromReconcileAll = (data) => {
    const oldList = [...reconcileList];
    const newList = oldList.filter(
      ({ uuid: id1 }) => !data.some(({ uuid: id2 }) => id2 === id1)
    );
    const oldAddedReconcileList = [...addedReconcile];
    const newAddedReconcileList = oldAddedReconcileList.filter(
      ({ uuid: id1 }) => !data.some(({ uuid: id2 }) => id2 === id1)
    );
    setAddedReconcile(newAddedReconcileList);
    setReconcileList(newList);
    const newRemovedList = [...removedReconcile];
    for (const item of data) {
      newRemovedList.push({ uuid: item });
    }
    // newRemovedList.push({ uuid: data })
    setRemovedReconcile(newRemovedList);
  };

  let initReconcile = {
    bank_pooling_uuid: "",
    diff_description: "",
    bank_statement_amount: 0,
    file: "",
    amount: 0,
    trx_date: moment().format("YYYY-MM-DD"),
    diff_amount: 0,
    bank_amount: 0,
  };
  // status rekonsiliasi
  let status = reconcileData ? reconcileData.status : "DRAFT";
  // console.log('====================================');
  // console.log(status);
  // console.log('====================================');

  const downloadFile = (uuid, settlement_hid) => {
    dispatch(actions.downloadReport(uuid, settlement_hid))
      .then((response) => { })
      .catch((error) => {
        toast.error(error.message, toastOption);
      });
  };

  const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    let totalDonationPayment;
    if (reconcileList.length > 0) {
      totalDonationPayment = reconcileList.reduce(
        (prev, curr) => prev + curr.amount,
        0
      );
      setSummaryData((prevState) => ({
        ...prevState,
        total_donation_payment: totalDonationPayment,
      }));
    } else {
      totalDonationPayment = 0;
      setSummaryData((prevState) => ({
        ...prevState,
        total_donation_payment: totalDonationPayment,
      }));
    }
    if (mutationBankData) {
      setSummaryData((prevState) => ({
        ...prevState,
        total_bank_statement: mutationBankData,
      }));
    }
    if (reconcileList.length > 0 && mutationBankData) {
      setSummaryData((prevState) => ({
        ...prevState,
        diff: +totalDonationPayment - +mutationBankData.amount,
      }));
    } else {
      setSummaryData((prevState) => ({
        ...prevState,
        diff: mutationBankData && +mutationBankData.amount,
      }));
    }
  }, [reconcileList, mutationBankData]);

  return (
    <>
      <SelectBankStatementModal
        show={bankStatementModal}
        onHide={() => setBankStatementModal(false)}
        selectedBankMutation={selectedBankMutation}
      />
      <Backdrop className={classes.backdrop} open={loadingProgress}>
        <ProgressBar now={loadingProgress} label={`${loadingProgress}%`} />
      </Backdrop>
      <Card>
        {/*{ actionsLoading && <ModalProgressBar/> }*/}
        <CardHeader title={title}>
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-light mr-2"
              onClick={backToList}
            >
              <i className="fa fa-arrow-left"></i>
              Back
            </button>

            {id && (
              <button
                type="button"
                className="btn btn-primary mr-2"
                onClick={() => {
                  setModalDisplay("BUKTI");
                  handleShow();
                }}
              >
                <i className="fa fa-eye"></i>Lihat Bukti Transfer
              </button>
            )}
            {/* {id && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  // window.open(`${DonationURL}reconcile/print/${id}`)
                  downloadFile(id, reconcileData.reconcile_hid);
                }}
              >
                <i class="fas fa-print"></i>Cetak Settlement
              </button>
            )} */}
            {`  `}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <ReconcileEditForm
            reconcile={initReconcile}
            reconcileData={reconcileData}
            btnCreateSettleRef={btnCreateSettleRef}
            amount={amountNonState}
            createSettleReconcile={createSettleReconcile}
            editDraftReconcile={editDraftReconcile}
            id={id}
            status={status}
            setSubmitValue={setSubmitValue}
            handleClickOpenDialogSettle={handleClickOpenDialogSettle}
            btnEditDraftRef={btnEditDraftRef}
            createDraftReconcile={createDraftReconcile}
            btnCreateDraftRef={btnCreateDraftRef}
            editSettleReconcile={editSettleReconcile}
            btnEditSettleRef={btnEditSettleRef}
            buttonType={buttonType}
            setButtonType={setButtonType}
            setBankAccount={setBankAccount}
            bankAccount={bankAccount}
            handleShow={handleShow}
            setModalDisplay={setModalDisplay}
          />
        </CardBody>
      </Card>

      <Card>
        <MutationBank
          openMutationBankModal={() => setBankStatementModal(true)}
          mutationBankData={[mutationBankData]}
          status={status}
        />
      </Card>

      <Card>
        <CardHeader title="Donation Payment">
          <CardHeaderToolbar>
            {BlockOrg() && (
              <>
                {status !== "SETTLE" && (
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setModalDisplay("DONASI");
                      handleShow();
                    }}
                  >
                    Cari Donasi
                  </button>
                )}
              </>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <ReconcileList
            ReconcileList={reconcileList}
            removeDonationFromReconcile={removeDonationFromReconcile}
            status={status}
          />
        </CardBody>
      </Card>
      <Card>
        <CardHeader title="Biaya Transaksi" />
        <CardBody>
          <SummaryTable data={[summaryData]} />
        </CardBody>
        <CardFooter>
          {status !== "SETTLE" && !id && (
            <button
              type="submit"
              className="btn btn-warning ml-2 float-right"
              onClick={createSettleReconcileClick}
            >
              Buat dan Settle Settlement
            </button>
          )}
          {status !== "SETTLE" && !id && (
            <button
              type="submit"
              className="btn btn-primary ml-2 float-right"
              onClick={createDraftReconcileClick}
            >
              Buat Draft
            </button>
          )}
          {BlockOrg() && (
            <>
              {status !== "SETTLE" && id && (
                <button
                  type="submit"
                  className="btn btn-primary ml-2 float-right"
                  onClick={editSettleReconcileClick}
                >
                  Simpan dan Settle Ubahan Draft
                </button>
              )}
            </>
          )}
          {BlockOrg() && (
            <>
              {status !== "SETTLE" && id && (
                <button
                  type="submit"
                  className="btn btn-warning ml-2 float-right"
                  onClick={editDraftReconcileClick}
                >
                  Simpan Ubahan Draft
                </button>
              )}
            </>
          )}
        </CardFooter>
      </Card>
      {reconcileData && status === "SETTLE" && (
        <Card>
          <CardHeader title="Informasi Settle"></CardHeader>
          <CardBody>
            <div className="card-body pt-4">
              <div className="timeline timeline-6">
                <div className="timeline-item align-items-start">
                  <div className="timeline-label font-weight-bolder text-dark-75 font-size-lg">
                    <Moment format="HH:mm">{reconcileData.settled_at}</Moment>
                  </div>

                  <div className="timeline-badge">
                    <i className="fa fa-genderless text-warning icon-xl"></i>
                  </div>

                  <div className="font-weight-mormal font-size-lg timeline-content text-muted pl-3">
                    <span className="text-primary ">
                      Eksekusi Settlement Pada Tanggal
                    </span>
                    ,&nbsp;
                    <span className="text-dark">
                      <Moment format="DD-MM-YYYY">
                        {reconcileData.created_at}
                      </Moment>
                    </span>
                    <div>
                      <div>Disettle Oleh : {reconcileData.settled_by}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      )}

      <>
        <Modal show={show} onHide={handleClose} keyboard={false} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              {modalDisplay === "BUKTI" ? "Bukti Transfer" : "Tambahkan Donasi"}
            </Modal.Title>
          </Modal.Header>
          {modalDisplay === "BUKTI" && (reconcileData && reconcileData.file) ? (
            <img
              src={`${reconcileData.file.storage}/${reconcileData.file.path}`}
              alt="Gambar Bukti Tidak Ditemukan"
            />
          ) : (
            <DonationList
              addDonationToReconcile={addDonationToReconcile}
              removeDonationFromReconcile={removeDonationFromReconcile}
              addDonationToReconcileAll={addDonationToReconcileAll}
              removeDonationFromReconcileAll={removeDonationFromReconcileAll}
              bankAccount={bankAccount}
            />
          )}

          <Modal.Footer>
            <button className="btn btn-secondary" onClick={handleClose}>
              Kembali
            </button>
          </Modal.Footer>
        </Modal>
      </>
      <div>
        <Dialog
          open={openDialogSettle}
          onClose={handleCloseDialogSettle}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Settle Settlement</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Anda Tidak Dapat Mengubah Data Settlement Ini Lagi Setelah
              Statusnya SETTLE, Apakah anda yakin ?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialogSettle} color="danger">
              Batal
            </Button>
            <Button
              onClick={() => {
                if (buttonType === "create_settle") {
                  createSettleReconcile(submitValue);
                } else if (buttonType === "edit_settle") {
                  editSettleReconcile(submitValue);
                }
              }}
              color="primary"
              autoFocus
            >
              Oke
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};
